import type { ValidationSchema } from 'validation-schema-library';

const TIME_SPENT_REGEX = /^\d+(\.\d+)?$|^\d+h( \d+m)?$|^\d+m$/;

const syberryTodaySpentTimeValidationSchema: ValidationSchema = {
  date: {
    type: 'date',
  },
  timeSpent: {
    type: 'string',
    required: true,
    regex: {
      value: TIME_SPENT_REGEX,
      message: 'Enter time as a decimal number of hours (e.g. 1.5) or a duration (e.g. 1h 30m)',
    },
  },
  comment: {
    type: 'string',
    required: true,
  },
  activity: {
    type: 'enum',
    required: true,
  },
};

export const getSyberryTodaySpentTimeValidationSchema = () => Promise.resolve(syberryTodaySpentTimeValidationSchema);
